import { Skeleton, Stack } from '@mui/material';
import React from 'react';
import PaperWrapper from './PaperWrapper';

const OrderItemCardSkeleton = () => {
  return (
    <PaperWrapper>
      <Stack height={{ xs: 222, md: 150 }} px="16px" gap="8px">
        <Skeleton variant="text" width={60} height={32} />
        <Skeleton variant="text" width="80%" sx={{ fontSize: 24 }} />
        <Skeleton
          variant="rounded"
          sx={{
            width: { xs: '50%', md: '100%' },
            height: { xs: 128, md: 56 },
          }}
        />
      </Stack>
    </PaperWrapper>
  );
};

export default OrderItemCardSkeleton;
